import { render, staticRenderFns } from "./PlanningCard.vue?vue&type=template&id=366e1342&scoped=true&lang=html&"
import script from "./PlanningCard.vue?vue&type=script&lang=js&"
export * from "./PlanningCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366e1342",
  null
  
)

export default component.exports